const save = (key, value, expirationSec, raiseEvent = true) => {
    if (typeof Storage === 'undefined') {
        return false;
    }
    const record = {value: value};
    if (!expirationSec) {
        record.isEternal = true;
    } else {
        const expirationMS = expirationSec * 1000;
        record.timestamp = new Date().getTime() + expirationMS;
    }
    localStorage.setItem(key, JSON.stringify(record));

    if (typeof window !== 'undefined' && raiseEvent) {
        window.dispatchEvent(new Event('storage'));
    }
    return value;
};
const load = (key, deleteAfterLoad = false) => {
    if (typeof Storage === 'undefined') {
        return false;
    }
    try {
        const record = JSON.parse(localStorage.getItem(key));
        if (!record) {
            return false;
        }
        if (deleteAfterLoad) {
            localStorage.removeItem(key);
        }
        if (record.isEternal) {
            return record.value;
        }
        if (record.timestamp) {
            return new Date().getTime() < record.timestamp && record.value;
        } else {
            return record;
        }
    } catch (e) {
        return false;
    }
};
export default {
    save: function(key, value, expirationSec) {
        return save(key, value, expirationSec);
    },
    load: function(key) {
        return load(key);
    },
    remove: function(key) {
        if (typeof Storage === 'undefined') {
            return false;
        }
        localStorage.removeItem(key);
    },
    loadOnce: function(key) {
        return load(key, true);
    },
    saveSilently: function(key, value, expirationSec) {
        return save(key, value, expirationSec, false);
    },
    saveItem: function(key, value) {
        if (typeof (Storage) === 'undefined') {
            return false;
        }
        localStorage.setItem(key, JSON.stringify(value));
        return value;
    },
    loadItem: function(key) {
        if (typeof (Storage) === 'undefined') {
            return false;
        }
        return JSON.parse(localStorage.getItem(key));
    },
};
